import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import AppSidebar from '../../components/AppSidebar';
import AppHeader from '../../components/AppHeader';
import PageHeader from '../../components/PageHeader';
import RequestHandler from './RequestHandler';
import configurationService from '../../services/ConfigurationsServices';
import { toast } from 'react-toastify';
import { useAuth } from '../../contexts/AuthContext';

const currency_API_URL = 'http://worldtimeapi.org/api/timezone';
const Currency = () => {
    const [currencies, setCurrencies] = useState([]);
    const { register, handleSubmit, reset, formState: { errors } } = useForm();
    const { user } = useAuth();

    useEffect(() => {
        const fetchCurrencies = async () => {
            try {
                const response = await axios.get(currency_API_URL);
                setCurrencies(response?.data?.map(currency => ({
                    id: currency,
                    name: currency,
                })) ?? []);
            } catch (error) {
                console.error('Failed to fetch currencies:', error);
            }
        };

        fetchCurrencies();
    }, []);

    const onSubmit = async (data) => {
        const requestBody = RequestHandler(data, "Currency", "configurations", null, true, user);
        console.log(requestBody);
        try {
            const response = await configurationService.createConfiguration(requestBody);

            if (response?.data?.status) { 
                toast.success(response?.data?.data?.message);
                reset();
            }
        } catch (error) {
            if (error?.response) { 
                const validationErrors = error?.response?.data?.data?.errors ?? [];
                validationErrors.forEach(err => {
                    console.error(`${err?.field}: ${err?.message}`); 
                    toast.error(`${err?.field}: ${err?.message}`);
                });
            } else {
                console.error('Failed to submit data:', error);
                toast.error('Something went wrong.');
            }
        }
    };

    return (
        <>
            <AppSidebar />
            <div className="main-content">
                <AppHeader />
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-10 col-xl-12">
                            <PageHeader title='Currency' />
                            <div className="card p-4">
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <div className="row">
                                        {/* Currency Select */}
                                        <div className="col-12 col-md-12">
                                            <div className="form-group">
                                                <label className="form-label">Default Currency</label>
                                                <select
                                                    {...register('currency')}
                                                    className="form-select"
                                                    aria-label="Default currency"
                                                >
                                                    <option value="">Select Currency</option>
                                                    {currencies?.map(currency => (
                                                        <option key={currency?.id} value={currency?.id}>{currency?.name}</option>
                                                    ))}
                                                </select>
                                                {errors?.currency && <div className="text-danger">{errors?.currency?.message}</div>}
                                                <hr />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='text-end'>
                                        <button type="submit" className="btn btn-primary">
                                            Save
                                        </button>
                                    </div>
                                </form>
                                <hr className="my-5" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Currency;
